import { safeDefine } from "../../registration/safe-define.js";
import { MinimalLiveVideoSkinElement } from "../../presets/live-video/minimal-skin.js";
import "../../internal/skins/minimal-live-video/register.js";
//#region src/define/live-video/minimal-skin.ts
safeDefine(MinimalLiveVideoSkinElement);
//#endregion
